<template>
    <div>
        <div class="wrap-start-header search pl16 pr16">
            <button class="btn-header back" @click="BackEvt()"></button>
            <div class="title-header">{{ $t('event_search') }}</div>
        </div>
        <event-list-component :event-type="'eventSearch'"></event-list-component>
    </div>
</template>


<script>
import memberMixins from "@/mixins/memberMixins";
import PageHeader from "@/components/PageHeader.vue";
import EventListComponent from "@/components/event/EventListComponent.vue";

export default {
    name: "EventSearch",
    mixins: [memberMixins],
    components: {
        PageHeader,
        EventListComponent,
    },
    props: {},
    data() {
        return {
            userType: "",
            ongoingEmpty: false,
            upcommingEmpty: false,
            pastEmpty: false,
            allEmpty: true,
        };
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
        BackEvt() {
            this.$router.back();
        },
    },
    watch: {},
};
</script>
